import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function Gateway() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Superadmin goes straight to their panel — no workspace choice needed
  useEffect(() => {
    if (user?.role === 'superadmin') navigate('/app', { replace: true });
  }, [user, navigate]);

  function handleBackToHome() {
    logout();
    navigate('/');
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a', color: '#ffffff',
      fontFamily: "'Segoe UI', system-ui, sans-serif", position: 'relative',
    }}>
      {/* Back to Home */}
      <div style={{ position: 'absolute', top: 24, left: 28 }}>
        <button
          onClick={handleBackToHome}
          style={{
            background: 'transparent', border: 'none', color: '#6b7280',
            fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, padding: 0,
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#f97316'}
          onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
        >
          ⏻ Logout
        </button>
      </div>

      {/* Logo */}
      <div style={{ position: 'absolute', top: 16, right: 28 }}>
        <img src="/maxxcom-logo.png" alt="MAXXCOM" style={{ height: 36, objectFit: 'contain' }} />
      </div>

      {/* Center Content */}
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '100vh', padding: '80px 24px',
      }}>
        <div style={{ marginBottom: 24 }}>
          <img src="/maxxcom-logo.png" alt="MAXXCOM" style={{ height: 64, objectFit: 'contain' }} />
        </div>

        <h1 style={{ fontSize: 30, fontWeight: 800, color: '#ffffff', marginBottom: 8, textAlign: 'center' }}>
          Welcome back, {user?.name || user?.email?.split('@')[0] || 'there'}
        </h1>
        <p style={{ fontSize: 16, color: '#6b7280', marginBottom: 8, textAlign: 'center' }}>
          Choose your workspace
        </p>
        <p style={{ fontSize: 12, color: '#374151', marginBottom: 44, textAlign: 'center', letterSpacing: 0.3 }}>
          An initiative by AcceleratorX
        </p>

        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
          {(user?.allowedApps || ['bot']).includes('bot') && (
            <GatewayCard
              icon="🤖"
              title="WhatsApp Bot Admin"
              description="Manage AI bots, view conversations, track leads, and configure your WhatsApp automation"
              buttonLabel="Open App →"
              solid
              onClick={() => navigate('/app')}
            />
          )}
          {(user?.allowedApps || []).includes('broadcaster') && (
            <GatewayCard
              icon="📢"
              title="WhatsApp Broadcaster"
              description="Send bulk messages, manage broadcast lists, schedule campaigns to your contacts"
              buttonLabel="Open Broadcaster →"
              solid={false}
              onClick={async () => {
                try {
                  const { data } = await api.post('/api/auth/broadcaster-token', {});
                  window.location.href = `https://broadcaster.maxxcom.in/sso?token=${encodeURIComponent(data.ssoToken)}`;
                } catch {
                  window.location.href = 'https://broadcaster.maxxcom.in';
                }
              }}
            />
          )}
          {(user?.allowedApps || []).includes('support_agent') && (
            <GatewayCard
              icon="🎫"
              title="Support Agent"
              description="Resolve learner queries with AI, manage support tickets, and configure DB connectors"
              buttonLabel="Open Support →"
              solid={false}
              onClick={() => navigate('/support-agent')}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function GatewayCard({ icon, title, description, buttonLabel, solid, onClick }) {
  const [hovered, setHovered] = useState(false);
  const [btnHover, setBtnHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: 300, background: hovered ? '#141414' : '#111111',
        border: `1px solid ${hovered ? '#f97316' : '#1f1f1f'}`,
        borderRadius: 20, padding: '40px 32px',
        boxShadow: hovered ? '0 0 30px rgba(249,115,22,0.15)' : 'none',
        transition: 'all 0.25s', display: 'flex', flexDirection: 'column', alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 60, marginBottom: 20, lineHeight: 1 }}>{icon}</div>
      <h3 style={{ fontSize: 19, fontWeight: 700, color: '#ffffff', marginBottom: 12 }}>{title}</h3>
      <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, marginBottom: 28, flex: 1 }}>{description}</p>
      <button
        onClick={onClick}
        onMouseEnter={() => setBtnHover(true)}
        onMouseLeave={() => setBtnHover(false)}
        style={{
          width: '100%', padding: '12px', borderRadius: 10,
          fontSize: 15, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
          ...(solid
            ? {
                background: btnHover ? '#ea580c' : '#f97316',
                border: 'none', color: '#fff',
              }
            : {
                background: 'transparent',
                border: `1px solid ${btnHover ? '#f97316' : '#333333'}`,
                color: btnHover ? '#f97316' : '#e5e5e5',
              }
          ),
        }}
      >
        {buttonLabel}
      </button>
    </div>
  );
}
